import React from "react";
import Nav from "@/components/Nav";
import Hero from "@/sections/Hero";
import Manifesto from "@/sections/Manifesto";
import Problema from "@/sections/Problema";
import ChiSiamo from "@/sections/ChiSiamo";
import Metodo from "@/sections/Metodo";
import Servizi from "@/sections/Servizi";
import Diagnosi from "@/sections/Diagnosi";
import Settori from "@/sections/Settori";
import CTAFinale from "@/sections/CTAFinale";
import Footer from "@/sections/Footer";

export default function Landing() {
  return (
    <>
      <Nav />
      <main data-testid="landing-main">
        <Hero />
        <Manifesto />
        <Problema />
        <ChiSiamo />
        <Metodo />
        <Servizi />
        <Diagnosi />
        <Settori />
        <CTAFinale />
      </main>
      <Footer />
    </>
  );
}
